'use client';
import { createContext, Dispatch, SetStateAction } from 'react';

interface ContextWithSetter {
  scrollToPosition: number;
  setScrollToPosition: Dispatch<SetStateAction<number>>;
}
export const CarProfileContext = createContext<ContextWithSetter>({
  scrollToPosition: 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setScrollToPosition: () => {},
});
